import compose from "compose-function";
import withRouter from "./with-router";
import withStore from './store';

export const withProviders = compose(withRouter, withStore);